// FR primary + EN translations for the whole site.
export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      informer: "S'informer",
      engager: "S'engager",
      inscrire: "S'inscrire",
      news: "Actualités",
      contact: "Contact",
      team: "L'équipe",
      formation: "Formation",
      members: "Espace membres",
    },
    hero: {
      eyebrow: "École démocratique · Hors contrat · Ariège",
      title: "École Pleine Nature",
      subtitle: "Ensemble scolaire démocratique élémentaire et secondaire à approche bilingue, en Ariège.",
      intro:
        "Un lieu d’apprentissage pour les jeunes de 6 à 18 ans, fondé sur les principes de l’éducation démocratique, l’EPN adopte une approche bilingue et repose sur des valeurs telles que la liberté, la responsabilité, la bienveillance, et le respect de l’humain et de la nature.",
      cta_informer: "S'informer",
      cta_inscrire: "S'inscrire",
      cta_engager: "S'engager",
      members_count: "99 membres",
      members_caption: "— enfants, équipe, familles, partenaires",
      quote_caption: "Projet d’école — association Petits Pas",
      quote_text: "« Nous considérons la diversité comme une richesse. »",
    },
    home: {
      pillars_eyebrow: "Notre approche",
      pillars_title: "Une école démocratique en pleine nature.",
      pillars_intro:
        "Quatre piliers structurent notre quotidien — au service d’un apprentissage profond, respectueux et durable.",
      pillars: [
        { title: "Apprentissages autodéterminés", text: "L’autodétermination des apprentissages s’opère par la liberté donnée aux enfants de choisir leurs activités, leurs rythmes et leurs centres d’intérêt, tout en étant accompagnés régulièrement pour relier leurs explorations personnelles aux compétences du socle commun." },
        { title: "Vie démocratique", text: "La vie démocratique à l’École Pleine Nature s’opère par une gouvernance partagée où chaque membre, enfant comme adulte, participe aux décisions de l’établissement via le Conseil d’École et le système de justice, en exerçant ses libertés dans un cadre commun qu’il peut proposer, discuter et faire évoluer." },
        { title: "Bienveillance et CNV", text: "L’équipe est formée à la Communication Non Violente. Écoute, coopération, un cadre bienveillant pour grandir." },
        { title: "Nature et ouverture", text: "Permaculture, sorties naturalistes, intervenants extérieurs, stages dès le cycle 4 : l’école s’inscrit dans le monde." },
      ],
      practical_eyebrow: "En pratique",
      practical_title: "L’essentiel, en un coup d’œil.",
      practical_intro:
        "École privée hors contrat, ancrée dans une vallée d’Ariège. Calendrier scolaire aligné, locaux adaptés, espaces repas et ALAE pour faciliter le quotidien des familles.",
      practical_cta: "Voir les informations pratiques",
      facts: [
        { label: "6 à 18 ans", sub: "Élémentaire & secondaire" },
        { label: "Moulis", sub: "près de Saint-Girons, Ariège" },
        { label: "Lun · Mar · Jeu · Ven", sub: "Calendrier scolaire" },
        { label: "84 enfants", sub: "99 membres au total" },
      ],
      status_label: "Statut",
      status_value: "École privée hors contrat",
      status_badge: "Association Petits Pas",
      testimonials_eyebrow: "Témoignages",
      testimonials_title: "Des voix qui composent l’école.",
      testimonials_intro: "Retrouvez les témoignages de familles, de membres et de visiteurs de l’École Pleine Nature.",
      testimonials_cta: "Lire les témoignages",
      final_eyebrow: "Faire connaissance",
      final_title: "Vous souhaitez en savoir plus ?",
      final_intro:
        "Découvrez en détail notre projet pédagogique, ou écrivez-nous directement. Nous prenons le temps de répondre à chaque famille.",
      final_cta_discover: "Découvrir le projet",
      final_cta_contact: "Contacter l’école",
    },
    temoignages: {
      eyebrow: "Témoignages",
      title: "Des voix qui composent l’école.",
      intro: "Familles, membres, intervenants et visiteurs partagent leur expérience de l’École Pleine Nature.",
      empty: "Les premiers témoignages seront publiés ici prochainement.",
      read_full: "Lire le témoignage complet",
      lang_note: "Témoignage rédigé en anglais",
      items: [],
    },
    don: {
      eyebrow: "Faire un don",
      title: "Soutenir l’École Pleine Nature",
      intro: "Votre don, ponctuel ou mensuel, aide l’école à grandir et à rester accessible à toutes les familles. Le formulaire sécurisé ci-dessous est fourni par HelloAsso.",
      tax: "Association reconnue d’intérêt général : 66 % de votre don est déductible de vos impôts. HelloAsso génère automatiquement votre reçu fiscal.",
      fallback: "Le formulaire ne s’affiche pas ? Ouvrir la page de don dans un nouvel onglet.",
    },
    formation: {
      eyebrow: "Formation",
      hero_title: "Deux formats pour vous accompagner",
      hero_subtitle: "Une immersion en présentiel à l’École Pleine Nature, ou une formation à distance en ligne : choisissez le format qui vous convient pour créer et gérer votre propre école démocratique.",
      format_presentiel_label: "En présentiel",
      format_presentiel_desc: "Immersion d’une semaine, en Ariège",
      format_online_label: "En ligne",
      format_online_desc: "6 modules à distance, 2 h chacun",
      title: "Formation présentielle à l’École Pleine Nature, Ariège",
      subtitle: "Prochaine session : 8 au 14 novembre 2026",
      heading: "Observer et comprendre le fonctionnement d’un établissement scolaire démocratique",
      intro: "Venez vivre une immersion dans la vie quotidienne de l’École Pleine Nature, et accédez au savoir-faire de l’école lors d’ateliers thématiques.",
      for_you_title: "Cette formation est pour vous, si vous vous sentez curieux·se de :",
      for_you_1: "Observer le fonctionnement d’une école démocratique",
      for_you_2: "Comprendre les valeurs, l’organisation pédagogique et institutionnelle de l’établissement",
      for_you_3: "Identifier les pratiques favorisant l’autonomie et la responsabilité des jeunes",
      for_you_4: "Analyser les modes de gouvernance partagée",
      for_you_5: "Découvrir des outils concrets de gestion d’équipe et de coopération",
      for_you_6: "Avancer dans votre projet grâce à l’analyse des pratiques observées",
      programme_title: "Déroulement de la semaine",
      welcome_title: "Dimanche — accueil",
      welcome_text: "Nous vous accueillons le dimanche de 16 h à 19 h, pour faire connaissance, vous familiariser avec les locaux et le fonctionnement général de l’école.",
      immersion_title: "Du lundi au vendredi — immersion",
      immersion_text: "Dès le lundi matin, vous entrez dans une posture d’observation et d’immersion au cœur de la vie des membres de l’École Pleine Nature (jeunes et adultes). Vous pourrez :",
      immersion_1: "Circuler librement dans les espaces de vie",
      immersion_2: "Observer les temps pédagogiques",
      immersion_3: "Observer les réunions",
      immersion_4: "Analyser les pratiques professionnelles",
      immersion_5: "Échanger avec les membres de l’équipe pédagogique",
      ateliers_title: "Ateliers thématiques (lundi au vendredi)",
      ateliers_text: "En complément de votre expérience immersive, vous accéderez à des ateliers thématiques délivrés par l’équipe pédagogique. L’opportunité d’approfondir certaines dimensions structurantes de notre établissement :",
      ateliers_1: "Historique et évolution de l’école",
      ateliers_2: "L’apprentissage démocratique, c’est quoi ?",
      ateliers_3: "Faire vivre la démocratie dans un collectif multi-âge",
      ateliers_4: "Faire éducation démocratique dans le contexte législatif français",
      ateliers_5: "Outils pour la vie de l’école",
      ateliers_6: "Philosophie et outils de gouvernance dans l’équipe",
      ateliers_7: "Outils de gestion administrative et ressources humaines",
      ateliers_8: "Stratégie financière et gestion comptable",
      ateliers_9: "Relation à l’extérieur : partenaires, parents, inspection",
      conclusion_title: "Samedi — clôture",
      conclusion_text: "Le samedi sera l’occasion de formaliser les apprentissages de la semaine passée, d’offrir votre regard analytique sur le projet d’école de l’EPN, de partager vos découvertes et d’avancer sur votre projet personnel.",
      dates_title: "Prochaines dates",
      dates_1: "Du 8 au 14 novembre 2026",
      dates_2: "Du 14 au 20 mars 2027",
      cancellation_title: "Annulation en cas d’effectif insuffisant",
      cancellation_intro: "Si le nombre d’inscrit·es est insuffisant à 7 jours de la session, nous nous réservons le droit de l’annuler. Vous pourrez alors choisir l’une des options suivantes :",
      cancellation_option_1: "Vous réinscrire à la prochaine session de formation.",
      cancellation_option_2: "Effectuer une immersion classique au sein de l’EPN, à la période de votre choix. Une immersion sans ateliers pédagogiques étant facturée 150 € la semaine, la différence vous sera remboursée.",
      cancellation_option_3: "Demander l’annulation de votre inscription et le remboursement intégral de la session.",
      hours_title: "Horaires",
      hours_sun: "Dimanche : 16 h – 19 h (accueil et lancement de la formation)",
      hours_weekdays: "Lundi, mardi, jeudi et vendredi : 9 h – 17 h (immersion et ateliers)",
      hours_wed: "Mercredi : 9 h – 17 h (ateliers thématiques)",
      hours_sat: "Samedi : 9 h – 12 h (débriefing, accompagnement des projets et clôture)",
      formateurs_title: "Formatrices",
      formateur_claire: "Claire Gaillardou — Facilitatrice d’apprentissage",
      formateur_louise: "Louise Barnard — Facilitatrice d’apprentissage",
      formateur_emilie: "Émilie Liberce — Facilitatrice d’apprentissage",
      formateur_magali: "Magali Dupuy — Facilitatrice d’apprentissage",
      formateurs_team_note: "Les facilitateur·ices ont chacun·es des rôles supplémentaires, dont la direction, la comptabilité et les ressources humaines.",
      formateur_salma: "Avec la participation de Salma Otmani — Ingénieure pédagogique.",
      tarifs_title: "Tarifs",
      tarifs_price: "600 € par participant",
      tarifs_signup: "Pour vous inscrire à cette formation, contactez Louise Barnard :",
      tarifs_contact_email: "louise@ecolepleinenature.org",
      tarifs_deposit: "Pour réserver votre place, nous vous demanderons un acompte de 15 %, soit un montant de 90 €.",
      financing_title: "Demande de financement",
      financing_intro: "Pour accéder à notre formation en bénéficiant d’un financement (OPCO, AIF, FAF, …), veuillez entrer en contact avec Éduscopie, notre organisme de formation certifié Qualiopi, en remplissant ce formulaire :",
      certified: "Organisme de formation certifié Qualiopi",
      hosted_by: "Nos formations sont hébergées par…",
      eduscopie_alt: "Eduscopie — habilitation formateur",
      form_fallback: "Le formulaire ne s’affiche pas ? Ouvrir dans un nouvel onglet.",
      brochure_button: "Télécharger la brochure (PDF)",
    },
    formationOnline: {
      eyebrow: "Formation en ligne",
      title: "Création et gestion d’un établissement scolaire démocratique",
      subtitle: "Prochaine session : 25 novembre au 12 décembre 2026 (6 modules de 2 h)",
      heading: "Une formation à distance pour porteur·se de projet d’école",
      intro: "Cette formation en ligne s’adresse aux porteurs·euses de projet d’école et aux responsables d’établissement scolaire, périscolaire, élémentaire et secondaire. Délivrée sur 6 modules de 2 heures, cette formation renforce votre compréhension des dimensions opérationnelles, pédagogiques et de gouvernance qui permettent le fonctionnement d’une école démocratique.",
      for_you_title: "Cette formation est pour vous, si vous vous sentez curieux·se de :",
      for_you_1: "Créer et gérer un établissement scolaire démocratique en étant en accord avec le cadre légal français",
      for_you_2: "Prendre en main la gestion administrative et financière",
      for_you_3: "Organiser efficacement la relation d’équipe et la relation avec les partenaires",
      for_you_4: "Acquérir les outils de gestion",
      trainers_intro: "Cette formation est co-animée par Claire Gaillardou et Louise Barnard, co-fondatrices de l’École Pleine Nature, qui fête cette année ses 10 ans.",
      experience_text: "Cette formation en ligne vous permettra d’accéder à des témoignages honnêtes sur les forces et faiblesses du projet. Vous profiterez d’une transmission opérationnelle des stratégies, postures et outils qui rendent ce projet pérenne, et vous expérimenterez des activités individuelles et de groupe qui vous aideront à progresser dans votre projet.",
      modules_title: "Les 6 modules de 2 heures",
      module1_title: "Module 1 — École démocratique et cadre légal",
      module1_1: "Présentation de l’École Pleine Nature",
      module1_2: "Les étapes de création d’une école démocratique en accord avec le cadre légal obligatoire",
      module2_title: "Module 2 — Gestion administrative",
      module2_1: "Être un Établissement Recevant du Public (ERP)",
      module2_2: "Être en règle avec l’Éducation nationale",
      module2_3: "Être en règle avec les familles",
      module3_title: "Module 3 — Ressources humaines",
      module3_1: "Animer les réunions d’équipe",
      module3_2: "Mettre en place une gouvernance adaptée",
      module3_3: "Favoriser l’horizontalité au sein de l’équipe",
      module4_title: "Module 4 — Gestion financière",
      module4_1: "Avoir une vision globale des pôles de dépense",
      module4_2: "Gérer les frais de scolarité",
      module4_3: "Gérer la trésorerie interne et externe",
      module4_4: "Diversifier les sources de revenus",
      module5_title: "Module 5 — Gestion des partenaires",
      module5_1: "Familles, Jeunesse et Sport, collectivités locales, fournisseurs de services…",
      module6_title: "Module 6 — Répondre aux attentes de l’Éducation nationale",
      module6_1: "Développer des outils de suivi des apprentissages des enfants",
      dates_title: "Prochaines dates",
      dates_1: "25 novembre 2026",
      dates_2: "28 novembre 2026",
      dates_3: "2 décembre 2026",
      dates_4: "5 décembre 2026",
      dates_5: "9 décembre 2026",
      dates_6: "12 décembre 2026",
      hours_title: "Horaires",
      hours_text: "9 h – 11 h, pour chacune des 6 sessions",
      formateurs_title: "Formatrices",
      formateur_claire: "Claire Gaillardou — Directrice de l’élémentaire, gestionnaire administrative, enseignante et facilitatrice de l’École Pleine Nature.",
      formateur_louise: "Louise Barnard — Directrice adjointe, enseignante et facilitatrice au sein de l’équipe pédagogique, gestionnaire financière, trésorière et co-responsable des ressources humaines de l’École Pleine Nature.",
      tarifs_title: "Tarifs",
      tarifs_solidaire: "Prix solidaire : 350 €",
      tarifs_personnel: "Prix personnel : 490 €",
      tarifs_commercial: "Prix commercial (OPCO) : 650 €",
      tarifs_signup: "Pour vous inscrire à cette formation, contactez Louise Barnard :",
      tarifs_contact_email: "louise@ecolepleinenature.org",
      tarifs_deposit: "Pour réserver votre place, nous vous demanderons un acompte de 15 %.",
      brochure_button: "Télécharger la brochure (PDF)",
    },
    team: {
      eyebrow: "L'équipe",
      title: "L'équipe pédagogique",
      intro: "Cliquez sur la fiche d'un membre de l'équipe pour découvrir son rôle, sa formation et ses centres d'intérêt.",
      empty: "L'équipe sera bientôt présentée ici.",
      view_sheet: "Voir la fiche",
      tab_roles: "Rôles & formation",
      tab_interests: "Centres d'intérêt",
      prev_page: "Page précédente",
      next_page: "Page suivante",
      snapshot_label: "Équipe au 1ᵉʳ septembre 2026",
      snapshot_text: "Cette photographie de l'équipe reflète un très large éventail de compétences, mises chaque jour à la disposition des enfants : pédagogie, langues, sciences, nature, sport, arts, cuisine, administration... Et ce n'est qu'un aperçu — chaque facilitateur·rice porte encore bien d'autres savoir-faire que ceux présentés sur ces fiches.",
    },
    memberx: {
      tab_login: "Se connecter",
      tab_request: "Demander un accès",
      request_intro: "Remplissez ce formulaire. Après vérification, l’équipe vous enverra un lien par e-mail pour créer votre mot de passe.",
      request_email_note: "Merci d’utiliser la même adresse e-mail que celle indiquée lors de l’inscription de votre enfant : l’accès est généralement accordé aux parents/responsables légaux des enfants actuellement inscrits.",
      f_name: "Nom complet",
      f_role: "Vous êtes",
      role_parent: "Parent",
      role_child: "Enfant / jeune",
      f_family: "Nom de famille",
      f_child: "Prénom de l’enfant (le cas échéant)",
      f_parent_email: "E-mail du parent (pour un enfant)",
      f_message: "Message (facultatif)",
      request_submit: "Envoyer ma demande",
      request_sent: "Merci ! Votre demande a bien été envoyée. L’équipe vous recontactera par e-mail.",
      forgot: "Mot de passe oublié ?",
      forgot_sent: "Si un compte existe, un e-mail de réinitialisation vient d’être envoyé.",
      forgot_submit: "Envoyer le lien",
      back_login: "Retour à la connexion",
      resources_title: "Ressources & documents",
      timetable: "Emploi du temps (mis à jour chaque semaine)",
      rules: "Règles de l’école",
      admin_requests_title: "Demandes d’accès",
      admin_no_requests: "Aucune demande pour le moment.",
      approve: "Approuver",
      reject: "Refuser",
      copy_link: "Copier le lien",
      link_copied: "Lien copié",
      admin_members_title: "Membres",
      send_reset: "Lien de réinitialisation",
      deactivate: "Désactiver",
      delete: "Supprimer",
      confirm_delete: "Supprimer définitivement ? Cette action est irréversible.",
      email_off_note: "E-mail non configuré : copiez le lien et envoyez-le manuellement.",
      pending: "En attente", approved: "Approuvée", rejected: "Refusée",
      role_member: "membre", role_admin: "administrateur",
    },
    setpw: {
      title: "Définir votre mot de passe",
      intro: "Choisissez un mot de passe pour accéder à l’espace membres.",
      password: "Nouveau mot de passe",
      confirm: "Confirmer le mot de passe",
      submit: "Enregistrer",
      success: "Mot de passe enregistré. Vous pouvez maintenant vous connecter.",
      invalid: "Ce lien est invalide ou a expiré.",
      go_login: "Aller à la connexion",
      mismatch: "Les mots de passe ne correspondent pas.",
      checking: "Vérification du lien…",
    },
    comprendre: {
      eyebrow: "Comprendre le projet",
      title: "Une école démocratique, entourée par la nature.",
      intro: "L’École Pleine Nature vise l’épanouissement global de chaque enfant, dans un cadre démocratique et bienveillant.",
      sections: [
        { n: "01", title: "Notre vision", text: "L’École Pleine Nature vise l’épanouissement global de chaque enfant et a pour ambition de former des citoyens responsables, engagés, ouverts sur le monde et pacifiques. L’autonomie, la connaissance de soi, l’ouverture à l’autre et le respect de l’environnement sont au cœur du projet éducatif." },
        { n: "02", title: "Ce qu’est une école démocratique", text: "Une école où chaque membre — enfants comme adultes — est invité à s’exprimer et à contribuer aux décisions concernant la vie de l’école. Conseil d’École hebdomadaire, Commissions, Cercles de Justice : un fonctionnement participatif et structuré, libre de tout prosélytisme." },
        { n: "03", title: "Liberté et responsabilité", text: "L’EPN ne confond pas apprentissage libre et absence de règles. Liberté et responsabilité se font écho : un cadre clair, des règles co-construites, et la confiance accordée à chaque jeune pour gagner en autonomie." },
        { n: "04", title: "Apprendre à son rythme", text: "Mixité des âges, apprentissages autodéterminés, projets et ateliers. Chaque enfant avance à son rythme vers les compétences du socle commun, accompagné par des adultes formés. Des professionnels interviennent régulièrement pour partager leur métier avec les jeunes." },
        { n: "05", title: "Le cadre légal et le socle commun", text: "Une intégration réaliste et pérenne ne se conçoit qu’à travers le respect du cadre légal français, en particulier l’acquisition du Socle Commun de Connaissances, de Compétences et de Culture (S4C). L’école est privée hors contrat." },
        { n: "06", title: "Bienveillance, CNV et résolution de conflits", text: "Les adultes sont formés à la Communication Non Violente et veillent à offrir un cadre bienveillant. Les conflits sont accueillis avec écoute, puis traités si besoin en Cercles de Justice." },
        { n: "07", title: "Nature, permaculture et environnement", text: "L’École Pleine Nature est un cadre d’apprentissage où les enfants développent un lien sensible au vivant et expérimentent des pratiques écologiques concrètes." },
        { n: "08", title: "Ouverture au monde", text: "Intervenants extérieurs, services civiques, ateliers, clubs, stages d’immersion en milieu professionnel dès le cycle 4 : l’école s’inscrit dans la société et favorise une mixité sociale, linguistique et culturelle (approche bilingue FR/EN)." },
      ],
      cta_title: "Vous pensez que ce projet pourrait correspondre à votre enfant ?",
      cta_inscrire: "Découvrir les admissions",
      cta_contact: "Contacter l’école",
      cta_pratique: "Voir les informations pratiques",
      formation_q: "Vous souhaitez créer votre propre école démocratique ?",
      formation_cta: "Découvrir notre formation",
    },
    calc: {
      eyebrow: "Simulateurs 2026",
      fees_title: "Calculateur des frais de scolarité 2026",
      qf_label: "Quotient familial",
      qf_placeholder: "Ex. 850",
      children_label: "Nombre d’enfants inscrits",
      child_one: "1 enfant",
      child_two: "2 enfants",
      child_three: "3 enfants",
      fees_result_label: "Frais de scolarité estimés",
      fees_monthly: "Soit environ {x} € / mois sur 12 mois",
      fees_note: "Cette simulation est donnée à titre indicatif sur la base de la grille tarifaire 2026.",
      alae_title: "Calculateur ALAE 2026",
      slots_label: "Nombre de tranches horaires utilisées",
      slot_one: "1 tranche",
      slot_two: "2 tranches",
      slot_three: "3 tranches",
      slots_hint: "Tranches possibles : matin, midi, soir. 2 tranches : matin + midi, midi + soir ou matin + soir. 3 tranches : matin + midi + soir.",
      alae_result_label: "Forfait ALAE estimé",
      alae_note: "Cette simulation est donnée à titre indicatif sur la base de la grille tarifaire ALAE 2026.",
      per_year: "/ an",
      qf_hint: "Saisissez votre quotient familial pour afficher une estimation.",
    },

    inscrire: {
      eyebrow: "Inscrire mon enfant",
      title: "Un parcours d’admission clair, en quatre étapes.",
      intro: "Nous prenons le temps de faire connaissance avec chaque famille. Voici comment se déroule une admission à l’École Pleine Nature.",
      for_who_title: "À qui s’adresse l’école ?",
      for_who_text: "Aux jeunes de 6 à 18 ans dont la famille adhère pleinement aux valeurs démocratiques, à la liberté responsable, à la mixité des âges et à la bienveillance comme cadre relationnel.",
      before_title: "Avant de demander une inscription",
      before_text_a: "Lisez attentivement ",
      before_link: "notre projet d’école",
      before_text_b: ". Nous demandons aussi à l’enfant d’exprimer, par une lettre, l’envie de rejoindre une école démocratique.",
      steps_title: "Les 4 étapes d’admission",
      steps: [
        {
          n: "1",
          title: "Lire et adhérer au projet d’école",
          text: "Prenez le temps de lire notre projet d’école. L’adhésion à nos valeurs est la première étape, pour vous et pour votre enfant.",
          link: "https://docs.google.com/document/d/14x6_hkFcM2-UPezSFhN5qaMnDMOJ_ev2bpkK0IhN4Gs/view",
          link_label: "Lire le projet d’école",
        },
        { n: "2", title: "S’inscrire sur liste d’attente", text: "L’inscription se fait par l’adhésion de la famille et du membre au projet d’école (entretien, prise de connaissance du projet, lettre de motivation du membre, fournir les documents légaux)." },
        { n: "3", title: "Préinscription : questionnaire, lettre & entretien", text: "Un questionnaire famille, une lettre de motivation de l’enfant, puis un entretien avec l’équipe pour faire connaissance." },
        { n: "4", title: "Période d’essai de 6 semaines", text: "Avant toute inscription définitive, 6 semaines sur place permettent à votre enfant — et à l’équipe — de valider la rencontre." },
      ],
      immersion_eyebrow: "Immersion enfant",
      immersion_title: "Une semaine pour découvrir, avant de candidater.",
      immersion_text: "Une immersion d’une semaine est possible pour l’enfant qui souhaite découvrir l’école avant d’engager une démarche d’admission. Tarif :",
      immersion_price: "85 €",
      immersion_cta: "Demander une immersion",
      practical_title: "Tarifs, horaires et vie quotidienne",
      practical_cards: [
        { title: "Tarifs & engagement", text: "Frais de scolarité solidaires, présentés en entretien. Adhésion annuelle à l’association." },
        { title: "Horaires", text: "Lundi, mardi, jeudi, vendredi · 9h15–16h15." },
        { title: "Repas", text: "Repas apportés par les familles. Espaces de réchauffage (pas de cantine sur place)." },
        { title: "ALAE", text: "Accueil de loisirs associé à l’école, avant et après la classe : 8h30–9h15, 12h–13h30 et 16h30–18h." },
      ],
      final_title: "Une question, une candidature ?",
      final_text: "Écrivez à l’équipe admission. Nous répondons à chaque message dans la semaine.",
      final_cta: "Contacter l’école pour une admission",
      adult_title: "Rejoindre l’école en tant qu’adulte",
      adult_text: "Vous souhaitez vous investir de façon régulière — comme intervenant·e, bénévole, volontaire en service civique ou stagiaire ? Découvrez les différentes façons de vous engager auprès de l’école.",
      adult_cta: "Candidater comme intervenant / bénévole",
    },
    immersions: {
      eyebrow: "Immersions & stages",
      title: "Observer, comprendre, se former auprès d’une école démocratique.",
      intro_a: "Cette page est destinée aux ",
      intro_b: "adultes",
      intro_c: " souhaitant venir à l’école. Pour l’inscription d’un enfant, rendez-vous sur la page ",
      intro_d: "Inscrire mon enfant",
      for_who_title: "Pour qui ?",
      for_who: [
        "Adultes en formation pédagogique",
        "Étudiants en stage (convention)",
        "Service civique",
        "Écoles partenaires",
        "Visiteurs souhaitant observer",
      ],
      observe_title: "Ce que vous pourrez observer",
      observe: [
        "La vie quotidienne de l’école",
        "Le Conseil d’École hebdomadaire",
        "Les Cercles de Justice",
        "Les ateliers, clubs et sorties",
        "Les documents pédagogiques",
      ],
      adult_eyebrow: "Immersion adulte",
      adult_title: "Une semaine sur place, en immersion respectueuse.",
      adult_text: "Observation, échanges, participation aux temps collectifs : vous découvrez le fonctionnement réel d’une école démocratique, dans le respect des règles et de la vie de l’école.",
      adult_price: "150 €",
      adult_per: "/ semaine",
      stages_title: "Stages avec convention",
      stages_text: "Stages possibles dans le cadre d’une formation, encadrés par une convention de stage tripartite. Précisez vos objectifs pédagogiques dans votre demande.",
      civic_title: "Service civique",
      civic_text: "Nous accueillons régulièrement des volontaires en service civique sur des missions définies en lien avec la vie de l’école et le projet associatif.",
      how_title: "Comment faire une demande",
      how_steps: [
        "Envoyez-nous un message en précisant votre profil, vos dates souhaitées et vos objectifs.",
        "Nous vous répondons sous quelques jours pour échanger.",
        "Une convention ou un document d’accueil est établi selon votre situation.",
      ],
      testimonial_quote: "",
      testimonial_author: "",
      final_title: "Prêt·e à venir nous rencontrer ?",
      final_cta: "Demander une immersion ou un stage",
    },
    engage: {
      eyebrow: "S'engager",
      title: "Participer, contribuer, soutenir l’école.",
      intro: "Il existe plusieurs manières de s’engager auprès de l’École Pleine Nature : venir observer en immersion, transmettre un savoir, donner de son temps, ou soutenir le projet.",
      adult_note_a: "Vous souhaitez inscrire un enfant ? Rendez-vous sur la page ",
      adult_note_b: "S'inscrire",
      adult_note_c: ".",
      visit_title: "Faire une immersion ou un stage",
      forms_title: "D’autres façons de s’engager",
      propose_title: "Proposer une activité ou une animation",
      propose_text: "Vous avez un savoir-faire, une passion ou un atelier à partager ? Proposez une activité, ponctuelle ou régulière, auprès des enfants.",
      propose_cta: "Proposer une activité",
      benevole_title: "Devenir bénévole",
      benevole_text: "Donnez du temps pour accompagner la vie quotidienne de l’école : ateliers, sorties, jardin, cuisine, bibliothèque, événements.",
      benevole_cta: "Devenir bénévole",
      partenaire_title: "Devenir partenaire",
      partenaire_text: "Associations, structures, entreprises ou collectivités : construisons ensemble des projets au service des enfants et du territoire.",
      partenaire_cta: "Devenir partenaire",
      soutenir_title: "Soutenir l’école",
      soutenir_text: "Soutenez le projet par un don ou une aide matérielle. Chaque contribution aide l’école à grandir et à rester accessible à toutes les familles.",
      soutenir_cta: "Soutenir l’école",
      soutenir_tax: "Association reconnue d’intérêt général : 66 % de votre don est déductible de vos impôts. Les dons sont collectés via HelloAsso, qui génère automatiquement votre reçu fiscal.",
      donate_banner_text: "Votre soutien permet à l’école de grandir et de rester accessible à toutes les familles.",
    },
    pratique: {
      eyebrow: "En pratique",
      title: "Toutes les informations utiles, en clair.",
      intro: "Locaux, horaires, repas, tarifs, ALAE, accès, contact. Cette page rassemble l’essentiel.",
      items: [
        { title: "Locaux", text: "Bâtiment principal au cœur d’une vallée en Ariège, ateliers, bibliothèque, espace extérieur et jardin." },
        { title: "Horaires", text: "Lundi, mardi, jeudi, vendredi · 9h15–16h15. Chaque matin, de 9h à 10h, des cours spécifiques seront proposés aux lycéens. La participation sera facultative. Ces temps seront consacrés à des apports pédagogiques proposés par des intervenants ou des membres de l’équipe." },
        { title: "Repas", text: "Repas apportés par les familles. Espaces de réchauffage disponibles (pas de cantine sur place)." },
        { title: "Tarifs", text: "Frais de scolarité solidaires, présentés en entretien. Adhésion annuelle à l’association." },
        { title: "ALAE", text: "Accueil de loisirs associé à l’école, en lien avec les structures locales. L’Accueil de Loisir Associé à l’École Pleine Nature se place en continuité du projet pédagogique de l’école, afin de pouvoir garantir un accueil des enfants déjà membres de l’école à l’élémentaire, de 8H30 à 09H15, entre 12H00 et 13H30 et de 16H30 à 18H00, sur le temps périscolaire." },
        {
          title: "Accès",
          text: "Moulis, près de Saint-Girons (09). Covoiturages entre familles fréquents.",
          link: "https://www.google.com/maps/search/?api=1&query=45+route+de+Mont%C3%A9gut+Lamb%C3%A8ge+09200+Moulis",
          link_label: "Voir sur Google Maps",
        },
      ],
      contact_eyebrow: "Adresse & contact",
      contact_school: "École Pleine Nature",
      address_l1: "45 route de Montégut",
      address_l2: "Lieu-dit Lambège",
      address_l3: "09200 Moulis",
      phone: "09 80 61 52 98",
      contact_cta: "Nous écrire",
    },
    actualites: {
      eyebrow: "Actualités",
      title: "Ce qui se vit à l’école.",
      intro: "Quelques nouvelles, événements et temps forts de la vie de l’École Pleine Nature.",
      empty: "Aucune actualité pour le moment.",
      coming_soon: "Les actualités arrivent bientôt.",
      error: "Impossible de charger les actualités.",
      read: "Lire",
      back: "Retour aux actualités",
      not_found_eyebrow: "Actualité introuvable",
      not_found_title: "Cette actualité n’existe pas.",
      cta_title: "Une question, un projet ?",
      cta_text: "Nous prenons le temps de répondre à chaque famille et visiteur.",
      cta_button: "Contacter l’école",
      padlet_eyebrow: "Calendrier",
      padlet_title: "Sorties et événements à venir",
      padlet_text: "Suivez les prochaines sorties et événements de l’école sur notre tableau Padlet, tenu à jour par l’équipe.",
      padlet_cta: "Voir le calendrier",
    },
    contact: {
      eyebrow: "Contact",
      title: "Écrivez-nous, nous prenons le temps de répondre.",
      intro: "Une question, un projet, une admission, une immersion ? Voici comment nous joindre.",
      email_title: "Email",
      address_title: "Adresse",
      note: "Pour une admission : précisez la date de naissance de l’enfant et la date souhaitée d’entrée. Pour une immersion adulte, indiquez vos dates et votre profil. Vous pouvez aussi nous joindre par téléphone au 09 80 61 52 98.",
      form_name: "Votre nom",
      form_name_placeholder: "Camille Durand",
      form_email: "Votre email",
      form_email_placeholder: "camille@exemple.fr",
      form_subject: "Sujet",
      form_message: "Message",
      form_message_placeholder: "Quelques mots sur votre demande…",
      form_send: "Envoyer",
      form_sending: "Envoi…",
      privacy: "Nous traitons vos messages avec confidentialité.",
      success: "Merci ! Votre message est bien arrivé. Un e-mail de confirmation vient de vous être envoyé et nous revenons vers vous très vite.",
      subjects: {
        general: "Question générale",
        inscription: "Inscription d'un enfant",
        benevolat: "Bénévolat ou intervention",
        immersion: "Immersion ou stage",
        partenariat: "Partenariat",
        soutien: "Soutenir l'école",
        autre: "Autre",
      },
    },
    members: {
      eyebrow: "Espace membres",
      title: "Espace membres",
      subtitle: "Réservé aux membres de l’école et à leurs parents ou représentants légaux.",
      welcome: "Bonjour,",
      role_label: "Vous êtes connecté·e en tant que",
      email: "Email",
      password: "Mot de passe",
      submit: "Se connecter",
      submitting: "Connexion…",
      logout: "Se déconnecter",
      cards: [
        { title: "Documents", text: "Comptes-rendus du Conseil d’École, calendriers, projet d’école." },
        { title: "Commissions", text: "Cuisine, jardin, bibliothèque, événements — l’organisation collective." },
        { title: "Annuaire", text: "Contacts internes, référents, parents délégués." },
      ],
    },
    admin_news: {
      eyebrow: "Administration",
      title: "Gérer les actualités",
      refresh: "Rafraîchir",
      form_title: "Nouvelle actualité",
      label_title: "Titre",
      placeholder_title: "Sortie nature au Pic des Trois Seigneurs",
      label_image: "Image (optionnel)",
      upload: "Téléverser",
      uploading: "Envoi…",
      upload_hint: "Choisissez une image depuis votre ordinateur (JPG, PNG, WEBP, GIF — 10 Mo max) ou collez une URL.",
      upload_success: "Image téléversée.",
      remove_image: "Retirer l’image",
      label_excerpt: "Chapeau (résumé court)",
      placeholder_excerpt: "Une phrase pour résumer l’actualité.",
      label_content: "Contenu",
      placeholder_content: "Le texte complet de l’actualité…",
      submit: "Publier",
      submitting: "Publication…",
      success_create: "Actualité publiée.",
      success_update: "Actualité mise à jour.",
      success_delete: "Actualité supprimée.",
      load_error: "Impossible de charger les actualités.",
      list_title: "Actualités existantes",
      list_empty: "Aucune actualité pour le moment.",
      list_loading: "Chargement…",
      delete: "Supprimer",
      edit: "Modifier",
      edit_title: "Modifier l’actualité",
      save: "Enregistrer",
      saving: "Enregistrement…",
      cancel: "Annuler",
      confirm_title: "Supprimer cette actualité ?",
      confirm_desc: "Cette action est irréversible. L’actualité ne sera plus visible sur le site.",
      confirm_yes: "Supprimer",
      confirm_no: "Annuler",
    },
    admin_contact: {
      eyebrow: "Boîte de réception",
      title: "Messages de contact",
      refresh: "Rafraîchir",
      load_error: "Impossible de charger les messages.",
      empty: "Aucun message pour le moment.",
      reply: "Répondre par email",
      delete: "Supprimer",
      confirm_delete: "Supprimer ce message ? Cette action est irréversible.",
      subjects: {
        general: "Général",
        inscription: "Inscription",
        benevolat: "Bénévolat / intervention",
        immersion: "Immersion / stage",
        partenariat: "Partenariat",
        soutien: "Soutien",
        autre: "Autre",
      },
    },
    common: {
      loading: "Chargement…",
      learn_more: "En savoir plus",
      donate: "Faire un don",
      back_home: "Retour à l’accueil",
      footer_school_doc: "Projet d’école",
      footer_testimonials: "Témoignages",
      mentions: "Mentions légales",
      footer_subtitle: "Ensemble scolaire démocratique élémentaire et secondaire à approche bilingue — pour les jeunes de 6 à 18 ans en Ariège.",
      footer_contact: "Contact",
      footer_resources: "Ressources",
      footer_phone_on_request: "Sur demande par e-mail",
      footer_copy: "Association Petits Pas",
      footer_made: "Fait avec soin, en Ariège.",
    },
    locale: "fr-FR",
  },
  en: {
    nav: {
      home: "Home",
      informer: "Discover",
      engager: "Get involved",
      inscrire: "Enrol",
      news: "News",
      contact: "Contact",
      team: "The team",
      formation: "Training",
      members: "Members",
    },
    hero: {
      eyebrow: "Democratic school · Out-of-contract · Ariège",
      title: "École Pleine Nature",
      subtitle: "A democratic, bilingual, private (out-of-contract) school in Ariège, France.",
      intro:
        "A learning community for young people aged 6 to 18. Founded on the principles of democratic education, École Pleine Nature offers a bilingual approach and is grounded in values such as freedom, responsibility, kindness, and respect for humans and nature.",
      cta_informer: "Discover",
      cta_inscrire: "Enrol",
      cta_engager: "Get involved",
      members_count: "99 members",
      members_caption: "— children, team, families, partners",
      quote_caption: "School project — Petits Pas association",
      quote_text: "“We consider diversity as a richness.”",
    },
    home: {
      pillars_eyebrow: "Our approach",
      pillars_title: "A democratic school in the heart of nature.",
      pillars_intro:
        "Four pillars shape our daily life — for deep, respectful and lasting learning.",
      pillars: [
        { title: "Self-directed learning", text: "Self-directed learning is enabled by the freedom given to children to choose their activities, pace and interests, while being regularly supported to connect their personal explorations to the national common-core competencies (Socle commun)." },
        { title: "Democratic life", text: "Democratic life at École Pleine Nature is enacted through shared governance where every member — child or adult — takes part in the school’s decisions via the School Council and the justice system, exercising their freedoms within a shared framework they can propose, discuss and evolve." },
        { title: "Kindness and NVC", text: "The team is trained in Nonviolent Communication. Active listening, cooperation, a kind framework to grow in." },
        { title: "Nature and openness", text: "Permaculture, nature outings, outside speakers, internships from cycle 4: the school is rooted in the world." },
      ],
      practical_eyebrow: "Practical info",
      practical_title: "The essentials, at a glance.",
      practical_intro:
        "Private out-of-contract school, in a valley of Ariège. School calendar aligned with national schedule, adapted premises, meal areas and after-school care.",
      practical_cta: "See practical information",
      facts: [
        { label: "Ages 6 to 18", sub: "Primary & secondary" },
        { label: "Moulis", sub: "near Saint-Girons, Ariège" },
        { label: "Mon · Tue · Thu · Fri", sub: "School calendar" },
        { label: "84 children", sub: "99 members in total" },
      ],
      status_label: "Status",
      status_value: "Private out-of-contract school",
      status_badge: "Petits Pas association",
      testimonials_eyebrow: "Voices",
      testimonials_title: "The voices that make our school.",
      testimonials_intro: "Read testimonials from families, members and visitors of École Pleine Nature.",
      testimonials_cta: "Read the testimonials",
      final_eyebrow: "Get in touch",
      final_title: "Would you like to know more?",
      final_intro:
        "Discover our educational project in detail, or simply write to us. We take the time to answer every family.",
      final_cta_discover: "Discover the project",
      final_cta_contact: "Contact the school",
    },
    temoignages: {
      eyebrow: "Testimonials",
      title: "The voices that make our school.",
      intro: "Families, members, instructors and visitors share their experience of École Pleine Nature.",
      empty: "The first testimonials will be published here soon.",
      read_full: "Read the full testimonial",
      lang_note: "Testimonial written in English",
      items: [],
    },
    don: {
      eyebrow: "Donate",
      title: "Support École Pleine Nature",
      intro: "Your one-time or monthly donation helps the school grow and stay accessible to every family. The secure form below is provided by HelloAsso.",
      tax: "As a recognised public-interest association, 66% of your donation is tax-deductible (France). HelloAsso automatically issues your tax receipt.",
      fallback: "Form not showing? Open the donation page in a new tab.",
    },
    formation: {
      eyebrow: "Training",
      hero_title: "Two formats to support you",
      hero_subtitle: "An in-person immersion at École Pleine Nature, or a remote online training: choose the format that suits you to create and run your own democratic school.",
      format_presentiel_label: "In person",
      format_presentiel_desc: "One-week immersion, in Ariège",
      format_online_label: "Online",
      format_online_desc: "6 remote modules, 2h each",
      title: "In-person training at École Pleine Nature, Ariège",
      subtitle: "Next session: 8 to 14 November 2026",
      heading: "Observing and understanding how a democratic school works",
      intro: "Come experience an immersion in the daily life of École Pleine Nature, and discover the school’s know-how through themed workshops.",
      for_you_title: "This training is for you if you are curious to:",
      for_you_1: "Observe how a democratic school operates",
      for_you_2: "Understand the values, pedagogical and institutional organisation of the school",
      for_you_3: "Identify practices that foster young people’s autonomy and responsibility",
      for_you_4: "Analyse shared governance methods",
      for_you_5: "Discover concrete tools for team management and cooperation",
      for_you_6: "Move forward with your project through the analysis of observed practices",
      programme_title: "How the week unfolds",
      welcome_title: "Sunday — welcome",
      welcome_text: "We welcome you on Sunday from 4 pm to 7 pm, to get to know each other, familiarise you with the premises and the school’s general organisation.",
      immersion_title: "Monday to Friday — immersion",
      immersion_text: "From Monday morning, you step into a posture of observation and immersion at the heart of the lives of École Pleine Nature’s members (young people and adults). You will be able to:",
      immersion_1: "Move freely through the living spaces",
      immersion_2: "Observe pedagogical moments",
      immersion_3: "Observe meetings",
      immersion_4: "Analyse professional practices",
      immersion_5: "Exchange with members of the pedagogical team",
      ateliers_title: "Themed workshops (Monday to Friday)",
      ateliers_text: "Alongside your immersive experience, you will take part in themed workshops led by the pedagogical team. The chance to explore in depth some of the structuring dimensions of our democratic school:",
      ateliers_1: "History and evolution of the school",
      ateliers_2: "What is democratic learning?",
      ateliers_3: "Keeping democracy alive within a multi-age collective",
      ateliers_4: "Democratic education within the French legal framework",
      ateliers_5: "Tools for school life",
      ateliers_6: "Philosophy and tools of governance within the team",
      ateliers_7: "Administrative management and human-resources tools",
      ateliers_8: "Financial strategy and accounting",
      ateliers_9: "Outward relationships: partners, parents, inspection",
      conclusion_title: "Saturday — closing",
      conclusion_text: "Saturday will be a time to formalise the learning of the past week, to share your analytical perspective on EPN’s school project, exchange your discoveries and move forward on your personal project.",
      dates_title: "Upcoming dates",
      dates_1: "8 to 14 November 2026",
      dates_2: "14 to 20 March 2027",
      cancellation_title: "Cancellation due to insufficient enrolment",
      cancellation_intro: "If there are not enough participants seven days before the session, we reserve the right to cancel it. You may then choose one of the following options:",
      cancellation_option_1: "Register for the next training session.",
      cancellation_option_2: "Take a standard immersion at EPN at a time of your choice. An immersion without educational workshops costs €150 per week, and the difference will be refunded.",
      cancellation_option_3: "Cancel your registration and receive a full refund for the session.",
      hours_title: "Schedule",
      hours_sun: "Sunday: 4 pm – 7 pm (welcome and training launch)",
      hours_weekdays: "Monday, Tuesday, Thursday and Friday: 9 am – 5 pm (immersion and workshops)",
      hours_wed: "Wednesday: 9 am – 5 pm (themed workshops)",
      hours_sat: "Saturday: 9 am – 12 pm (debriefing, project support and closing)",
      formateurs_title: "Trainers",
      formateur_claire: "Claire Gaillardou — Learning facilitator",
      formateur_louise: "Louise Barnard — Learning facilitator",
      formateur_emilie: "Émilie Liberce — Learning facilitator",
      formateur_magali: "Magali Dupuy — Learning facilitator",
      formateurs_team_note: "Each facilitator also holds additional responsibilities, including leadership, accounting and human resources.",
      formateur_salma: "With the participation of Salma Otmani — Learning designer.",
      tarifs_title: "Fees",
      tarifs_price: "€600 per participant",
      tarifs_signup: "To register for this training, contact Louise Barnard:",
      tarifs_contact_email: "louise@ecolepleinenature.org",
      tarifs_deposit: "To secure your place, we ask for a 15% deposit, i.e. €90.",
      financing_title: "Funding request",
      financing_intro: "To attend our training with funding support (OPCO, AIF, FAF, etc.), please get in touch with Éduscopie, our Qualiopi-certified training organisation, by filling in this form:",
      certified: "Qualiopi-certified training organisation",
      hosted_by: "Our training courses are hosted by…",
      eduscopie_alt: "Eduscopie — trainer accreditation",
      form_fallback: "Form not showing? Open it in a new tab.",
      brochure_button: "Download the brochure (PDF)",
    },
    formationOnline: {
      eyebrow: "Online training",
      title: "Creating and running a democratic school",
      subtitle: "Next session: 25 November to 12 December 2026 (6 modules)",
      heading: "A remote training for school-project founders",
      intro: "This online training is designed for people setting up a school project and for those responsible for a school, after-school, primary or secondary institution. Delivered over 6 two-hour modules, this training strengthens your understanding of the operational, pedagogical and governance dimensions that make a democratic school work.",
      for_you_title: "This training is for you if you are curious to:",
      for_you_1: "Create and run a democratic school in line with the French legal framework",
      for_you_2: "Take charge of administrative and financial management",
      for_you_3: "Effectively organise team relationships and relationships with partners",
      for_you_4: "Acquire management tools",
      trainers_intro: "This training is co-led by Claire Gaillardou and Louise Barnard, co-founders of École Pleine Nature, which celebrates its 10th anniversary this year.",
      experience_text: "This online training will give you access to honest accounts of the project’s strengths and weaknesses. You will benefit from a hands-on transmission of the strategies, postures and tools that make this project sustainable, and you will take part in individual and group activities to help you move forward with your own project.",
      modules_title: "The 6 two-hour modules",
      module1_title: "Module 1 — Democratic school and legal framework",
      module1_1: "Introduction to École Pleine Nature",
      module1_2: "The steps to set up a democratic school in line with the mandatory legal framework",
      module2_title: "Module 2 — Administrative management",
      module2_1: "Being an Establishment Open to the Public (ERP)",
      module2_2: "Being compliant with the Ministry of Education",
      module2_3: "Being compliant with families",
      module3_title: "Module 3 — Human resources",
      module3_1: "Running team meetings",
      module3_2: "Setting up a suitable governance model",
      module3_3: "Fostering horizontality within the team",
      module4_title: "Module 4 — Financial management",
      module4_1: "Having an overall view of spending areas",
      module4_2: "Managing tuition fees",
      module4_3: "Managing internal and external cash flow",
      module4_4: "Diversifying income sources",
      module5_title: "Module 5 — Managing partners",
      module5_1: "Families, Youth & Sports authorities, local government, service providers…",
      module6_title: "Module 6 — Meeting Ministry of Education expectations",
      module6_1: "Developing tools to track children’s learning",
      dates_title: "Upcoming dates",
      dates_1: "25 November 2026",
      dates_2: "28 November 2026",
      dates_3: "2 December 2026",
      dates_4: "5 December 2026",
      dates_5: "9 December 2026",
      dates_6: "12 December 2026",
      hours_title: "Schedule",
      hours_text: "9 am – 11 am, for each of the 6 sessions",
      formateurs_title: "Trainers",
      formateur_claire: "Claire Gaillardou — Director of the primary school, administrative manager, teacher and facilitator at École Pleine Nature.",
      formateur_louise: "Louise Barnard — Deputy director, teacher and facilitator within the pedagogical team, financial manager, treasurer and co-head of human resources at École Pleine Nature.",
      tarifs_title: "Fees",
      tarifs_solidaire: "Solidarity price: €350",
      tarifs_personnel: "Individual price: €490",
      tarifs_commercial: "Business price (OPCO): €650",
      tarifs_signup: "To register for this training, contact Louise Barnard:",
      tarifs_contact_email: "louise@ecolepleinenature.org",
      tarifs_deposit: "To secure your place, we ask for a 15% deposit.",
      brochure_button: "Download the brochure (PDF)",
    },
    team: {
      eyebrow: "The team",
      title: "The teaching team",
      intro: "Click on a team member's card to discover their role, training and interests.",
      empty: "The team will be introduced here soon.",
      view_sheet: "View the sheet",
      tab_roles: "Roles & training",
      tab_interests: "Interests",
      prev_page: "Previous page",
      next_page: "Next page",
      snapshot_label: "Team as of 1 September 2026",
      snapshot_text: "This snapshot of the team reflects a very broad range of skills made available to the children every day: pedagogy, languages, science, nature, sport, arts, cooking, administration, and more. And this is only a glimpse — each facilitator brings many more abilities than what's shown on these sheets.",
    },
    memberx: {
      tab_login: "Sign in",
      tab_request: "Request access",
      request_intro: "Fill in this form. After verification, the team will email you a link to create your password.",
      request_email_note: "Please use the same email address you provided during your child’s enrolment — access is usually granted to parents/guardians of currently enrolled children.",
      f_name: "Full name",
      f_role: "You are",
      role_parent: "Parent",
      role_child: "Child / young person",
      f_family: "Family name",
      f_child: "Child's first name (if applicable)",
      f_parent_email: "Parent's email (for a child)",
      f_message: "Message (optional)",
      request_submit: "Send my request",
      request_sent: "Thank you! Your request has been sent. The team will get back to you by email.",
      forgot: "Forgot password?",
      forgot_sent: "If an account exists, a reset email has just been sent.",
      forgot_submit: "Send the link",
      back_login: "Back to sign in",
      resources_title: "Resources & documents",
      timetable: "Timetable (updated every week)",
      rules: "School rules",
      admin_requests_title: "Access requests",
      admin_no_requests: "No requests for now.",
      approve: "Approve",
      reject: "Reject",
      copy_link: "Copy link",
      link_copied: "Link copied",
      admin_members_title: "Members",
      send_reset: "Reset link",
      deactivate: "Deactivate",
      delete: "Delete",
      confirm_delete: "Delete permanently? This cannot be undone.",
      email_off_note: "Email not configured: copy the link and send it manually.",
      pending: "Pending", approved: "Approved", rejected: "Rejected",
      role_member: "member", role_admin: "administrator",
    },
    setpw: {
      title: "Set your password",
      intro: "Choose a password to access the members area.",
      password: "New password",
      confirm: "Confirm password",
      submit: "Save",
      success: "Password saved. You can now sign in.",
      invalid: "This link is invalid or has expired.",
      go_login: "Go to sign in",
      mismatch: "Passwords do not match.",
      checking: "Checking the link…",
    },
    calc: {
      eyebrow: "2026 calculators",
      fees_title: "2026 tuition fee calculator",
      qf_label: "Family quotient (quotient familial)",
      qf_placeholder: "e.g. 850",
      children_label: "Number of enrolled children",
      child_one: "1 child",
      child_two: "2 children",
      child_three: "3 children",
      fees_result_label: "Estimated tuition fees",
      fees_monthly: "That is about {x} € / month over 12 months",
      fees_note: "This simulation is indicative, based on the 2026 fee scale.",
      alae_title: "2026 ALAE calculator",
      slots_label: "Number of time slots used",
      slot_one: "1 slot",
      slot_two: "2 slots",
      slot_three: "3 slots",
      slots_hint: "Slots: morning, midday, evening. 2 slots: morning + midday, midday + evening or morning + evening. 3 slots: morning + midday + evening.",
      alae_result_label: "Estimated ALAE package",
      alae_note: "This simulation is indicative, based on the 2026 ALAE fee scale.",
      per_year: "/ year",
      qf_hint: "Enter your family quotient to see an estimate.",
    },
    comprendre: {
      eyebrow: "Our project",
      title: "A democratic school, surrounded by nature.",
      intro: "École Pleine Nature aims at the holistic flourishing of each child, within a democratic and kind setting.",
      sections: [
        { n: "01", title: "Our vision", text: "École Pleine Nature aims at the holistic flourishing of each child, with the ambition to nurture responsible, engaged, open-minded and peaceful citizens. Autonomy, self-knowledge, openness to others and respect for the environment are at the heart of our educational project." },
        { n: "02", title: "What a democratic school is", text: "A school where every member — children and adults — is invited to speak up and contribute to the decisions about school life. Weekly School Council, committees, Justice Circles: a participatory, structured way of running an institution, free from any proselytising." },
        { n: "03", title: "Freedom and responsibility", text: "EPN does not confuse free learning with the absence of rules. Freedom and responsibility echo each other: a clear framework, co-built rules, and the trust given to each young person to grow in autonomy." },
        { n: "04", title: "Learning at your own pace", text: "Mixed ages, self-directed learning, projects and workshops. Each child moves at their own pace towards the national common-core competencies (Socle commun), guided by trained adults. Professionals regularly come to share their trade with the young people." },
        { n: "05", title: "Legal framework and common core", text: "A realistic and lasting integration only makes sense within the French legal framework, in particular the acquisition of the Common Core of Knowledge, Skills and Culture (S4C). The school is private out-of-contract." },
        { n: "06", title: "Kindness, NVC and conflict resolution", text: "Adults are trained in Nonviolent Communication and ensure a kind, safe framework. Conflicts are welcomed with active listening and, when needed, addressed in Justice Circles." },
        { n: "07", title: "Nature, permaculture and environment", text: "École Pleine Nature is a learning setting where children develop a sensitive bond with the living world and experiment with concrete ecological practices." },
        { n: "08", title: "Openness to the world", text: "Outside speakers, civic-service volunteers, workshops, clubs, professional-immersion internships from cycle 4: the school is embedded in society and fosters social, linguistic and cultural diversity (bilingual FR/EN approach)." },
      ],
      cta_title: "Could this project be a fit for your child?",
      cta_inscrire: "See admissions",
      cta_contact: "Contact the school",
      cta_pratique: "See practical information",
      formation_q: "Interested in setting up your own democratic school?",
      formation_cta: "Discover our training",
    },
    inscrire: {
      eyebrow: "Enrol a child",
      title: "A clear admissions path, in four steps.",
      intro: "We take time to get to know each family. Here is how an admission to École Pleine Nature unfolds.",
      for_who_title: "Who is the school for?",
      for_who_text: "Young people aged 6 to 18 whose family fully embraces democratic values, responsible freedom, mixed ages and kindness as a relational framework.",
      before_title: "Before requesting an enrolment",
      before_text_a: "Read ",
      before_link: "our school project",
      before_text_b: " carefully. We also ask the child to express, in a short letter, their wish to join a democratic school.",
      steps_title: "The 4 admission steps",
      steps: [
        {
          n: "1",
          title: "Read and embrace the school project",
          text: "Take time to read our school project. Adhering to our values is the first step, for you and for your child.",
          link: "https://docs.google.com/document/d/14x6_hkFcM2-UPezSFhN5qaMnDMOJ_ev2bpkK0IhN4Gs/view",
          link_label: "Read the school project",
        },
        { n: "2", title: "Join the waiting list", text: "Enrolment goes through the family’s and the member’s adherence to the school project (interview, discovery of the project, motivation letter from the member, provision of legal documents)." },
        { n: "3", title: "Pre-enrolment: questionnaire, letter & interview", text: "A family questionnaire, a motivation letter from the child, then an interview with the team to get to know each other." },
        { n: "4", title: "6-week trial period", text: "Before any final enrolment, 6 weeks on site lets your child — and the team — confirm the match." },
      ],
      immersion_eyebrow: "Child immersion",
      immersion_title: "A week to discover, before applying.",
      immersion_text: "A one-week immersion is possible for a child wishing to discover the school before starting an admission process. Fee:",
      immersion_price: "€85",
      immersion_cta: "Request an immersion",
      practical_title: "Fees, schedule and daily life",
      practical_cards: [
        { title: "Fees & commitment", text: "Solidarity-based school fees, discussed during the interview. Annual association membership." },
        { title: "Schedule", text: "Monday, Tuesday, Thursday, Friday · 9:15am–4:15pm." },
        { title: "Meals", text: "Meals brought by families. Reheating areas available (no on-site canteen)." },
        { title: "After-school care", text: "ALAE, before and after class: 8:30–9:15am, 12–1:30pm and 4:30–6pm." },
      ],
      final_title: "A question, an application?",
      final_text: "Write to the admissions team. We answer every message within the week.",
      final_cta: "Contact the school about admissions",
      adult_title: "Joining the school as an adult",
      adult_text: "Would you like to get involved on a regular basis — as an instructor, volunteer, civic-service volunteer or intern? Discover the different ways to get involved with the school.",
      adult_cta: "Apply as instructor / volunteer",
    },
    immersions: {
      eyebrow: "Immersions & internships",
      title: "Observe, understand, train with a democratic school.",
      intro_a: "This page is for ",
      intro_b: "adults",
      intro_c: " wishing to visit the school. To enrol a child, head to the ",
      intro_d: "Enrol a child",
      for_who_title: "Who is it for?",
      for_who: [
        "Adults in educational training",
        "Students on an internship (with convention)",
        "Civic-service volunteers",
        "Partner schools",
        "Visitors wishing to observe",
      ],
      observe_title: "What you will be able to observe",
      observe: [
        "Daily life at the school",
        "The weekly School Council",
        "Justice Circles",
        "Workshops, clubs and outings",
        "Educational documents",
      ],
      adult_eyebrow: "Adult immersion",
      adult_title: "A respectful week on site.",
      adult_text: "Observation, conversations, participation in collective times: you discover the real workings of a democratic school, while respecting its rules and life.",
      adult_price: "€150",
      adult_per: "/ week",
      stages_title: "Internships with convention",
      stages_text: "Internships are possible as part of a training programme, framed by a tripartite convention. Please specify your learning objectives in your request.",
      civic_title: "Civic service",
      civic_text: "We regularly welcome civic-service volunteers on missions defined together, in connection with school life and the association project.",
      how_title: "How to apply",
      how_steps: [
        "Send us a message with your profile, preferred dates and objectives.",
        "We get back to you within a few days to discuss.",
        "A convention or welcome document is set up depending on your situation.",
      ],
      testimonial_quote: "",
      testimonial_author: "",
      final_title: "Ready to come and meet us?",
      final_cta: "Request an immersion or internship",
    },
    engage: {
      eyebrow: "Get involved",
      title: "Take part, contribute, support the school.",
      intro: "There are several ways to get involved with École Pleine Nature: come and observe during an immersion, share a skill, give some of your time, or support the project.",
      adult_note_a: "Wish to enrol a child? Head to the ",
      adult_note_b: "Enrol",
      adult_note_c: " section.",
      visit_title: "Do an immersion or internship",
      forms_title: "Other ways to get involved",
      propose_title: "Propose an activity or a workshop",
      propose_text: "Do you have a skill, a passion or a workshop to share? Propose a one-off or regular activity with the children.",
      propose_cta: "Propose an activity",
      benevole_title: "Become a volunteer",
      benevole_text: "Give some of your time to support the school's daily life: workshops, outings, garden, kitchen, library, events.",
      benevole_cta: "Become a volunteer",
      partenaire_title: "Become a partner",
      partenaire_text: "Associations, organisations, businesses or local authorities: let's build projects together that serve the children and the local area.",
      partenaire_cta: "Become a partner",
      soutenir_title: "Support the school",
      soutenir_text: "Support the project through a donation or material help. Every contribution helps the school grow and stay accessible to all families.",
      soutenir_cta: "Support the school",
      soutenir_tax: "As a recognised public-interest association, 66% of your donation is tax-deductible (France). Donations are collected via HelloAsso, which automatically issues your tax receipt.",
      donate_banner_text: "Your support helps the school grow and stay open to every family.",
    },
    pratique: {
      eyebrow: "Practical info",
      title: "All the useful information, in plain language.",
      intro: "Premises, schedule, meals, fees, after-school care, access, contact. This page brings together the essentials.",
      items: [
        { title: "Premises", text: "Main building in the heart of an Ariège valley, workshops, library, outdoor space and garden." },
        { title: "Schedule", text: "Monday, Tuesday, Thursday, Friday · 9:15am–4:15pm. Every morning from 9:00 to 10:00, specific classes will be offered to high-school students. Participation will be optional. These sessions will be dedicated to educational input from instructors or members of the school team." },
        { title: "Meals", text: "Meals brought by families. Reheating areas available (no on-site canteen)." },
        { title: "Fees", text: "Solidarity-based school fees, discussed during the interview. Annual association membership." },
        { title: "After-school care", text: "Connected to local structures, integrated with the school." },
        {
          title: "Access",
          text: "Moulis, near Saint-Girons (09). Family carpooling is common.",
          link: "https://www.google.com/maps/search/?api=1&query=45+route+de+Mont%C3%A9gut+Lamb%C3%A8ge+09200+Moulis",
          link_label: "View on Google Maps",
        },
      ],
      contact_eyebrow: "Address & contact",
      contact_school: "École Pleine Nature",
      address_l1: "45 route de Montégut",
      address_l2: "Lieu-dit Lambège",
      address_l3: "09200 Moulis",
      phone: "09 80 61 52 98",
      contact_cta: "Write to us",
    },
    actualites: {
      eyebrow: "News",
      title: "Life at the school.",
      intro: "A few news items, events and highlights from École Pleine Nature.",
      empty: "No news yet.",
      coming_soon: "News coming soon.",
      error: "Unable to load news.",
      read: "Read",
      back: "Back to news",
      not_found_eyebrow: "Not found",
      not_found_title: "This news item doesn’t exist.",
      cta_title: "A question, a project?",
      cta_text: "We take the time to answer every family and visitor.",
      cta_button: "Contact the school",
      padlet_eyebrow: "Calendar",
      padlet_title: "Upcoming outings and events",
      padlet_text: "Follow our upcoming outings and events on our Padlet board, kept up to date by the team.",
      padlet_cta: "Open the calendar",
    },
    contact: {
      eyebrow: "Contact",
      title: "Write to us — we take the time to reply.",
      intro: "A question, a project, an admission, an immersion? Here is how to reach us.",
      email_title: "Email",
      address_title: "Address",
      note: "For an admission: please mention the child’s date of birth and preferred entry date. For an adult immersion, please give your dates and profile. You can also reach us by phone at 09 80 61 52 98.",
      form_name: "Your name",
      form_name_placeholder: "Alex Smith",
      form_email: "Your email",
      form_email_placeholder: "alex@example.com",
      form_subject: "Subject",
      form_message: "Message",
      form_message_placeholder: "A few words about your request…",
      form_send: "Send",
      form_sending: "Sending…",
      privacy: "We treat your messages with confidentiality.",
      success: "Thank you! Your message has arrived. A confirmation email is on its way and we’ll get back to you very soon.",
      subjects: {
        general: "General question",
        inscription: "Child enrolment",
        benevolat: "Volunteering or intervention",
        immersion: "Immersion or internship",
        partenariat: "Partnership",
        soutien: "Support the school",
        autre: "Other",
      },
    },
    members: {
      eyebrow: "Members",
      title: "Members area",
      subtitle: "Reserved for school members and their parents/guardians.",
      welcome: "Hello,",
      role_label: "You are logged in as",
      email: "Email",
      password: "Password",
      submit: "Sign in",
      submitting: "Signing in…",
      logout: "Sign out",
      cards: [
        { title: "Documents", text: "School Council minutes, calendars, school project." },
        { title: "Committees", text: "Kitchen, garden, library, events — collective organisation." },
        { title: "Directory", text: "Internal contacts, leads, parent delegates." },
      ],
    },
    admin_news: {
      eyebrow: "Administration",
      title: "Manage news",
      refresh: "Refresh",
      form_title: "New news item",
      label_title: "Title",
      placeholder_title: "Nature outing at Pic des Trois Seigneurs",
      label_image: "Image (optional)",
      upload: "Upload",
      uploading: "Uploading…",
      upload_hint: "Choose an image from your computer (JPG, PNG, WEBP, GIF — 10 MB max) or paste a URL.",
      upload_success: "Image uploaded.",
      remove_image: "Remove image",
      label_excerpt: "Excerpt (short summary)",
      placeholder_excerpt: "One sentence summarising the news.",
      label_content: "Content",
      placeholder_content: "The full text of the news item…",
      submit: "Publish",
      submitting: "Publishing…",
      success_create: "News published.",
      success_update: "News updated.",
      success_delete: "News deleted.",
      load_error: "Unable to load news.",
      list_title: "Existing news",
      list_empty: "No news yet.",
      list_loading: "Loading…",
      delete: "Delete",
      edit: "Edit",
      edit_title: "Edit news item",
      save: "Save",
      saving: "Saving…",
      cancel: "Cancel",
      confirm_title: "Delete this news item?",
      confirm_desc: "This action cannot be undone. The news item will no longer be visible on the site.",
      confirm_yes: "Delete",
      confirm_no: "Cancel",
    },
    admin_contact: {
      eyebrow: "Inbox",
      title: "Contact messages",
      refresh: "Refresh",
      load_error: "Unable to load messages.",
      empty: "No messages yet.",
      reply: "Reply by email",
      delete: "Delete",
      confirm_delete: "Delete this message? This cannot be undone.",
      subjects: {
        general: "General",
        inscription: "Enrolment",
        benevolat: "Volunteering / intervention",
        immersion: "Immersion / internship",
        partenariat: "Partnership",
        soutien: "Support",
        autre: "Other",
      },
    },
    common: {
      loading: "Loading…",
      learn_more: "Learn more",
      donate: "Donate",
      back_home: "Back to home",
      footer_school_doc: "School project",
      footer_testimonials: "Testimonials",
      mentions: "Legal notice",
      footer_subtitle: "Democratic, bilingual, private out-of-contract school — for young people aged 6 to 18 in Ariège, France.",
      footer_contact: "Contact",
      footer_resources: "Resources",
      footer_phone_on_request: "On request by email",
      footer_copy: "Petits Pas association",
      footer_made: "Made with care, in Ariège.",
    },
    locale: "en-GB",
  },
};
